<tran-application-detail-dashboard-box [heading]="heading()">
    @if (isLoading()) {
        <div class="py-4 flex flex-col gap-4" aria-hidden="true">
            <span class="si-skeleton placeholder-lg w-[60%]"></span>
            <span class="si-skeleton placeholder-lg w-full"></span>
            <span class="si-skeleton placeholder-lg w-full"></span>
            <span class="si-skeleton placeholder-lg w-[65%]"></span>
            <span class="si-skeleton placeholder-lg w-[65%]"></span>
        </div>
    } @else {
        <form [formGroup]="activeForm()">
            <si-form-item
                [label]="
                    'components.application-detail-dashboard.application-responsibilities.involved-responsibilities'
                        | translate
                "
            >
                <si-form-item label="">
                    <div class="flex items-center gap-4">
                        <div class="flex items-center w-[30%]">
                            <tran-checkbox
                                [label]="
                                    'components.application-detail-dashboard.application-responsibilities.learning-and-growth-partner'
                                        | translate
                                "
                                [readonly]="true"
                                [isChecked]="!!activeForm().controls.learningAndGrowthPartner.value"
                            />
                        </div>
                        <div class="flex items-center w-[70%]">
                            <tran-people-select
                                class="w-full"
                                [control]="activeForm().controls.learningAndGrowthPartner"
                                [readonly]="readonly()"
                            />
                        </div>
                    </div>
                </si-form-item>
                <si-form-item label="">
                    <div class="flex items-center gap-4">
                        <div class="flex items-center w-[30%]">
                            <tran-checkbox
                                [label]="
                                    'components.application-detail-dashboard.application-responsibilities.workers-council'
                                        | translate
                                "
                                [readonly]="true"
                                [isChecked]="!!activeForm().controls.workersCouncil.value"
                            />
                        </div>
                        <div class="flex items-center w-[70%]">
                            <tran-people-select
                                class="w-full"
                                [control]="activeForm().controls.workersCouncil"
                                [readonly]="readonly()"
                            />
                        </div>
                    </div>
                </si-form-item>
                <si-form-item label="">
                    <div class="flex items-center gap-4">
                        <div class="flex items-center w-[30%]">
                            <tran-checkbox
                                [label]="
                                    'components.application-detail-dashboard.application-responsibilities.additional-partners'
                                        | translate
                                "
                                [readonly]="true"
                                [isChecked]="(activeForm().controls.additionalPartners.value?.length ?? 0) > 0"
                            />
                        </div>
                        <div class="flex items-center w-[70%]">
                            <tran-people-select
                                multi="true"
                                class="w-full"
                                [control]="activeForm().controls.additionalPartners"
                                [readonly]="readonly()"
                            />
                        </div>
                    </div>
                </si-form-item>
            </si-form-item>
        </form>

        <tran-application-detail-people
            label="components.application-detail-dashboard.application-responsibilities.business-responsibility"
            [people]="activeForm().controls.businessResponsible.value ?? []"
            [control]="activeForm().controls.businessResponsible"
            [readonly]="readonly()"
        />

        <tran-application-detail-people
            label="components.application-detail-dashboard.application-responsibilities.technical-responsibility"
            [people]="activeForm().controls.technicalResponsible.value ?? []"
            [control]="activeForm().controls.technicalResponsible"
            [readonly]="readonly()"
        />

        <tran-application-detail-people
            label="components.application-detail-dashboard.application-responsibilities.commercial-responsibility"
            [people]="activeForm().controls.commercialResponsible.value ?? []"
            [control]="activeForm().controls.commercialResponsible"
            [readonly]="readonly()"
        />
    }
</tran-application-detail-dashboard-box>
